module.exports = __webpack_public_path__ + "media/images/permira-1339aa52.png";